import { getStats } from '../../api';
import { useFetch } from '../../hooks';
import { Button, TopPanel } from '../../components';

type StatsCardProps = {
  label: string;
  number: number;
  children?: React.ReactNode;
};

const StatsCard: React.FC<StatsCardProps> = ({ label, number, children }) => {
  return (
    <div className="p-lg rounded-md bg-bg text-text">
      <div className="mb-xs font-medium text-small uppercase">{label}</div>
      <div className="font-bold text-heading py-md text-main">{number}</div>
      {!!children && (
        <div className="mt-md pt-md border-t border-active text-text font-medium">
          {children}
        </div>
      )}
    </div>
  );
};

const Statistics = () => {
  const {
    data,
    initializing: loading,
    refresh,
    reloading,
  } = useFetch(getStats, []);

  return (
    <div className="flex flex-col gap-y-md w-full">
      <TopPanel>
        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>
      {!loading && !!data && (
        <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-lg">
          <StatsCard label="Tasks" number={data.tasks.total}>
            <div>Pending {data.tasks.pending}</div>
            <div>Completed {data.tasks.completed}</div>
          </StatsCard>
          <StatsCard label="Contacts" number={data.contacts} />
          <StatsCard label="Webhook Events" number={data.webhook_events} />
          <StatsCard label="System Prompts" number={data.prompts} />
        </div>
      )}
    </div>
  );
};

export default Statistics;
